// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c07fb903","239":"769a6105","455":"e1730861"}[chunkId] + ".chunk.js";
};